import React from 'react';
import { UnlockFreeMasterclassContainer } from './UnlockFreeMasterclass.styles';
import Paragraph from 'src/elements/typography/paragraph';
import ButtonPrimary from 'src/elements/buttons/2023_Q4/ButtonPrimary';
import { usePeopleMagicProfitEmailModalControl } from 'src/organisms/Standard/ProfitSales/2024_Q3_profit_sales_redesign/EmailModal/usePeopleMagicProfitEmailModalControl';
import { palette } from 'src/styles/colors';
import Unlock from 'src/images/Unlock';

const UnlockFreeMasterclass = (): JSX.Element => {
  const { open } = usePeopleMagicProfitEmailModalControl();

  return (
    <UnlockFreeMasterclassContainer>
      <Paragraph
        text='IMAGINE BEING HANDED THE BLUEPRINT TO A $1M COMMUNITY WITH AI'
        standardSize='1.125'
        align='left'
        weight={400}
      />
      <ButtonPrimary
        text='Unlock the FREE Masterclass'
        standardSize='1.125'
        colorScheme='Black'
        onClick={open}
        customBorderColor={palette.black}
        icon={
          <Unlock
            color='white'
            width={16}
          />
        }
        iconPosition='left'
      />
    </UnlockFreeMasterclassContainer>
  );
};

export default UnlockFreeMasterclass;
